// extracted by mini-css-extract-plugin
export default {"mainContent":"XWgQCHXuKjl3JkPM9elD","more":"XERfTDnTVyh3oDkFHH2Q"};